export enum TreasuryCTEvents {
  CARD_VIEW_LOADED = 'card_view_loaded',
  CARD_VIEW_ERROR = 'card_view_error'
}
